import { render, staticRenderFns } from "./Trainorder.vue?vue&type=template&id=8d142eb4&scoped=true"
import script from "./Trainorder.vue?vue&type=script&lang=js"
export * from "./Trainorder.vue?vue&type=script&lang=js"
import style0 from "./Trainorder.vue?vue&type=style&index=0&id=8d142eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d142eb4",
  null
  
)

export default component.exports